import { render } from "./AppDialogHost.vue?vue&type=template&id=3cb137de&scoped=true&ts=true"
import script from "./AppDialogHost.vue?vue&type=script&lang=ts"
export * from "./AppDialogHost.vue?vue&type=script&lang=ts"

import "./AppDialogHost.vue?vue&type=style&index=0&id=3cb137de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb137de"]])

export default __exports__